import React, { useEffect, useState } from 'react'
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { TimePicker } from '@mui/x-date-pickers';
import { TextField } from '@mui/material';
import dayjs from 'dayjs';
import { useDispatch, useSelector } from 'react-redux';
import { getStaffs, setClearOrder, setSelectedTimeRangeForUIShow } from '../../../redux/reducers/createOrderSlice';
import { rescheduleJob } from '../../../redux/reducers/myOrdersSlice';
import { useNavigate } from 'react-router-dom';
import DropDownForTimeSelection from '../../BookingForm/GeneralRegularBooking/DropDownForTimeSelection';
import { loadingContentForStaffAvailability, timeSelectionArrayForDay, timeSelectionArrayForNight } from '../../../utils/constants';
import { setLoadingContent } from '../../../redux/reducers/loadingSlice';
import { isBeforeApril1st2024 } from '../../../utils/createOrderCommonFunctions';
const RescheduleBox = ({ showScheduleBox, setShowScheduleBox, selectedJobDetails, setSelectedJobDetails }) => {
    const [jobCreate, setJobCreate] = useState({})
    const dispatch = useDispatch()
    const { hasStaffAvailable } = useSelector((state) => state.createOrderSlice)
    const [reasonFieldValue, setReasonFieldValue] = useState("")
    const [timeRangeArray, setTimeRangeArray] = useState([])
    const navigate = useNavigate()
    const [errors, setErrors] = useState({});
    const updateJobObject = (item, value) => {
        setJobCreate((prev) => {
            return {
                ...prev,
                [item]: value
            }
        })
    }
    const selectTime = (item) => {
        let oldTime = new Date(selectedJobDetails?.startDate)
        let newTime = new Date(item)
        newTime?.setHours(oldTime.getHours())
        newTime?.setMinutes(oldTime.getMinutes())
        updateJobObject('startDate', newTime.toISOString())
        validateForm();
        if (!!jobCreate.endDate) {
            newTime.setHours(newTime.getHours() + (new Date(selectedJobDetails.endDate).getHours() - new Date(selectedJobDetails.startDate).getHours()))
            updateJobObject('endDate', newTime.toISOString())
        }
    }
    const selectStartTime = (item) => {
        let newTime = new Date(jobCreate.startDate)
        newTime.setHours(new Date(item).getHours())
        newTime.setMinutes(new Date(item).getMinutes())
        updateJobObject('startDate', newTime.toISOString())
        newTime.setHours(newTime.getHours() + (new Date(selectedJobDetails.endDate).getHours() - new Date(selectedJobDetails.startDate).getHours()))
        updateJobObject('endDate', newTime.toISOString())
        validateForm();
    }
    const handleGetAllAvailableStaffs = () => {
        dispatch(getStaffs({
            dispatch,
            values: {
                location: selectedJobDetails?.location,
                orderType: selectedJobDetails?.order_id?.orderType,
                startDate: jobCreate?.startDate,
                endDate: jobCreate?.endDate,
                staffNeeded: 1,
                preferredStaffs: jobCreate?.isStaff === "preferredStaff" ? selectedJobDetails?.order_id?.preferredStaffs : [],
                serviceArray: selectedJobDetails?.serviceArray,
                finalSubmit: true,
                jobId: selectedJobDetails?._id
            },
        }))
    }
    useEffect(() => {
        if (jobCreate?.startDate && jobCreate.endDate) {
            handleGetAllAvailableStaffs()
        }
    }, [jobCreate])
    useEffect(() => {
        if (!selectedJobDetails?.order_id?.preferredStaffs?.length > 0) {
            updateJobObject("isStaff", "preferredStaff")
        }

    }, [selectedJobDetails])
    const handleCreateJob = () => {
        if (isFormValid() && hasStaffAvailable) {
            let jobBodyData = {
                "createdFor": selectedJobDetails?.customerUserId?._id,
                "location": selectedJobDetails?.location,
                "orderType": selectedJobDetails?.order_id?.orderType,
                "address": selectedJobDetails?.address,
                "formatedAddress": selectedJobDetails?.address?.formatedAddress,
                "additionalMessage": selectedJobDetails?.order_id?.additionalMessage,
                "sessions": selectedJobDetails?.order_id?.sessions,
                "startDate": jobCreate?.startDate,
                "endDate": jobCreate?.endDate,
                "reason": reasonFieldValue ?? "",
                "unitNo": selectedJobDetails?.address?.unitNo ?? '',
                "serviceArray": selectedJobDetails?.jobServiceArray ?? [],
                "order_id": selectedJobDetails?.order_id?._id,
                "staffNeeded": selectedJobDetails?.order_id?.preferredStaffs.length > 0 ? jobCreate?.isStaff === "preferredStaff" ? selectedJobDetails?.order_id?.preferredStaff : jobCreate?.isStaff === "anyStaff" ? 1 : 1 : 1,
                "finalSubmit": true,
                "oldJob": selectedJobDetails,
                "preferredStaffs": selectedJobDetails?.order_id?.preferredStaffs.length ? jobCreate?.isStaff === "preferredStaff" ? selectedJobDetails?.order_id?.preferredStaffs : [] : []
            }
            dispatch(rescheduleJob({ data: jobBodyData, navigate: navigate, dispatch }))
        }
    }
    const validateForm = () => {
        const newErrors = {};

        if (!jobCreate?.startDate) {
            newErrors.date = 'Date is required';
        }





        setErrors(newErrors);
    };
    const isFormValid = () => Object.keys(errors).length === 0;

    const handleGenerate = () => {

        const result = [];
        const duration = { hours: (new Date(selectedJobDetails.endDate).getHours() - new Date(selectedJobDetails.startDate).getHours()), minutes: 0, seconds: 0 };
        const timeIntervals = selectedJobDetails?.order_id?.recurenceRule?.timePreference?.includes('Day') ?
            timeSelectionArrayForDay(duration.hours) : timeSelectionArrayForNight(duration.hours)    // for(let i=0; i<selectionArr.length; i++){
        for (let i = 0; i < timeIntervals.length; i++) {
            const startTime = timeIntervals[i];
            const endTime = {
                hours: startTime.hours + duration.hours,
                minutes: startTime.minutes + duration.minutes,
                seconds: startTime.seconds + duration.seconds,
            };
            result.push({ startTime, endTime, id: `timeRange-${i + 1}` });
        }
        if (result.length > 0) {
            setTimeRangeArray(result)
        }

    }
    useEffect(() => {
        if (selectedJobDetails?._id) {
            handleGenerate()
        }
    }, [selectedJobDetails])
    return (
        <div className="des bookighide">
            <p className="mb-0 re-d">Reschedule Date and Time:</p>
            <div className="row align-items-end" style={{ gap: '10px' }}>
                {(selectedJobDetails?.order_id?.preferredStaffs?.length > 0 && selectedJobDetails?.order_id?.orderType?.toLowerCase() === "regular") &&
                    <div className="col-md-12">
                        <div className="staff-selection options">
                            <div className="col-lg-6 col-md-6 options">
                                <div className="radio">
                                    <input className={`reschedule-radio`} type="radio" name="staffType" id="staffType1" value="preferredStaff" onChange={(e) => updateJobObject("isStaff", e.target.value)} checked={jobCreate?.isStaff === "preferredStaff"} />
                                    <label htmlFor="staffType1">
                                        <div className="pricing-word-c">
                                            <h5>Reschedule with same staff</h5>
                                        </div>
                                    </label>

                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6 options">
                                <div className="radio">
                                    <input className={`reschedule-radio`} type="radio" name="staffType" id="staffType2" value="anyStaff" onChange={(e) => updateJobObject("isStaff", e.target.value)} checked={jobCreate?.isStaff === "anyStaff"} />
                                    <label for="staffType2">
                                        <div className="pricing-word-c">
                                            <h5>Use any staff (more availability)</h5>
                                        </div>
                                    </label>
                                </div>
                            </div>
                        </div>

                    </div>
                }
                <div className="col-md-12">
                    <div className="booking-date">
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DemoContainer components={['DatePicker']}>
                                <DatePicker format='DD/MM/YYYY' onChange={(newValue) => selectTime(newValue.toISOString())}
                                    minDate={isBeforeApril1st2024() ? dayjs(new Date('2024-04-01T00:00:00.000')) : dayjs(new Date().setDate(new Date().getDate() + 2))}
                                />
                            </DemoContainer>
                        </LocalizationProvider>
                    </div>
                </div>
                <div className="col-md-12 staff-selection">
                    <DropDownForTimeSelection
                        options={timeRangeArray}
                        onChange={(val) => {
                            dispatch(setSelectedTimeRangeForUIShow(val))
                            selectStartTime(new Date(0, 0, 0, val?.startTime?.hours, val?.startTime?.minutes, val?.startTime?.seconds)?.toISOString())
                        }
                        }
                        disableCondition={!jobCreate?.startDate}
                    />
                </div>
                {/* {(!jobCreate?.startDate || !jobCreate?.endDate) && <p className='form-error-message' style={{ fontWeight: '500' }}>Select date and time</p>} */}
                <div className="col-md-12">
                    <div className="bookingtexta">
                        <p className="mb-0 re-d">Reason for rescheduling</p>
                        <textarea name="" id="" onChange={(e) => setReasonFieldValue(e.target.value.trim())}></textarea>
                    </div>
                </div>
            </div>
            <div className="note">
                Note: Rescheduling is highly dependent on our
                availability. If you are serviced by a preferred staff,
                you may be getting a replacement for this session.
            </div>
            <div className="d-flex align-items-center justify-content-end">
                <div className="bookingcancle cursor-pointer" onClick={() => { setShowScheduleBox(!showScheduleBox); setSelectedJobDetails(null); dispatch(setClearOrder()) }}>
                    CANCEL
                </div>
                <div className={`up-green up-red ${(isFormValid() && hasStaffAvailable) && "up-gray"}`} >
                    <p className={`mb-0 cursor-${(isFormValid() && hasStaffAvailable) ? 'pointer' : 'not-allowed'}`} onClick={handleCreateJob}>PROCEED TO RESCHEDULE</p>
                </div>
            </div>

        </div>
    )
}

export default RescheduleBox